import SettingsNavbar from 'components/organisms/SettingsNavbar/SettingsNavbar';
import { Outlet } from 'react-router-dom';
import './SettingsTemplate.scss';

const SettingsTemplate = () => {
  return (
    <div className='settings-template'>
      <div className='navbar'>
        <SettingsNavbar />
      </div>
      <div className='settings'>
        <Outlet />
      </div>
    </div>
  );
};

export default SettingsTemplate;
